<template>
  <div v-if="repostCount > 0 || quoteCount > 0 || likeCount > 0" class="interaction-stats d-flex align-center gap-6 py-2 border-y border-white-05 mt-2 px-2">
    <div 
      v-if="repostCount > 0" 
      class="stat-item cursor-pointer hover-link d-flex align-center gap-1"
      @click="$emit('show-reposts')"
    >
      <span class="font-weight-black text-white">{{ formatNumber(repostCount) }}</span>
      <span class="text-grey-lighten-1">&nbsp;{{ repostCount === 1 ? 'repost' : 'reposts' }}</span>
      &nbsp;
    </div>
    
    <div 
      v-if="quoteCount > 0" 
      class="stat-item cursor-pointer hover-link d-flex align-center gap-1"
      @click="$emit('show-quotes')"
    >
      <span class="font-weight-black text-white">{{ formatNumber(quoteCount) }}</span>
      <span class="text-grey-lighten-1">&nbsp;{{ quoteCount === 1 ? 'quote' : 'quotes' }}</span>
    </div>

    <div 
      v-if="likeCount > 0" 
      class="stat-item cursor-pointer hover-link d-flex align-center gap-1"
      @click="$emit('show-likes')"
    >
      <span class="font-weight-black text-white">{{ formatNumber(likeCount) }}</span>
      <span class="text-grey-lighten-1">&nbsp;{{ likeCount === 1 ? 'like' : 'likes' }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  repostCount: number;
  quoteCount: number;
  likeCount: number;
}>();

defineEmits(['show-reposts', 'show-quotes', 'show-likes']);

const formatNumber = (num: number) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toString();
};
</script>

<style scoped>
.interaction-stats {
  font-size: 0.95rem;
  letter-spacing: -0.01em;
}

.stat-item {
  transition: opacity 0.2s;
  flex-shrink: 0;
  white-space: nowrap;
}

.stat-item:hover {
  opacity: 0.8;
}

.hover-link:hover .text-white {
  text-decoration: underline;
}

.border-y {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.text-grey-lighten-1 {
  color: #8899a6 !important;
}
</style>
